<template>
  <div class="login">
    <div class="login-div">
      <div>
        <!-- <img class="img-title" src="../assets/login-title.png" alt="" /> -->
      </div>
      <div class="login-form">
        <comLogin v-if="isLogin" :sendData="getData"></comLogin>
        <comSign v-else :sendData="getData"></comSign>
      </div>
    </div>
  </div>
</template>

<script>
import comSign from "../components/comSign";
import comLogin from "../components/comLogin.vue";
export default {
  name: "Login",
  data() {
    return {
      isLogin: true,
    };
  },
  components: {
    comSign,
    comLogin,
  },
  methods: {
    getData(val) {
      this.isLogin = val;
    },
  },
};
</script>
<style lang="scss" scoped>
.login {
  width: 100vw;
  height: 1270px;
  background: url("../assets/login-bg.png");
  background-position: center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-div {
  width: 70%;
  height: 50%;
  // background: pink;
  display: flex;
  justify-content: space-between;
  .img-title {
    width: 663px;
    height: 166px;
    padding-top: 100px;
    overflow: hidden;
  }
  .login-form {
    width: 40%;
    height: 100%;
    background: rgb(20, 20, 20, 0.8);
    border-radius: 20px;
    .form-box {
      margin: 40px;
      .form-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title-reg {
          font-size: 26px;
          color: #fff;
          font-weight: bold;
        }
        .title-pass {
          font-size: 16px;
          color: #938e8e;
          span {
            color: #ff9000;
            cursor: pointer;
          }
        }
      }
      .demo-ruleForm {
        margin-top: 50px;
      }
      .but-div {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
      }
      .submitBut {
        background: #ff9000;
        border: 1px solid #ff9000;
        color: #000;
        font-size: 18px;
        font-weight: bold;
        width: 215px;
      }
      .input-div {
        display: flex;
        align-items: center;
        .input-icon {
          width: 30px;
          height: 43px;
          position: absolute;
          left: 10px; /* 根据需要调整 */
          top: 50%;
          transform: translateY(-50%);
          z-index: 1; /* 确保图标在输入框上方 */
        }
        .newCode {
          width: 27px;
          height: 31px;
        }
        .newPass {
          width: 25px;
          height: 33px;
        }
      }
    }
  }
}
::v-deep .el-input__inner {
  background: #474545;
  border: 1px solid #474545;
  color: #fff;
  padding: 30px 0;
  padding-left: 60px;
  height: 50px;
}
::v-deep .el-input-group__append {
  background: #474545;
  border: 1px solid #474545;
  cursor: pointer;
  color: #fff;
}
</style>
